import { z } from 'zod';
/**
 * Closed vocabularies shared by the database (CHECK constraints in /sql),
 * the API, the UI, and the Claude structured-output schema.
 * Changing a value here is a schema migration. See docs/BUILD.md §5.
 */
/** Who performs a step. Non-negotiable 6: judgment, negotiation, and client trust default to human. */
export const PerformedBy = z.enum(['human', 'agent', 'hybrid']).describe('human: a person does this. agent: an automated agent does this end to end. ' +
    'hybrid: an agent prepares the work and a person decides or confirms.');
/** Node kind in the process graph. Drives Mermaid shape and graph invariants. */
export const StepType = z.enum(['start', 'task', 'decision', 'wait', 'end']).describe('start: the single trigger. task: work is done. decision: two or more labeled outcomes. ' +
    'wait: time passes with no work (waiting on a client, a system, another team). end: a terminal outcome.');
export const RaciLetter = z.enum(['R', 'A', 'C', 'I']);
export const SystemUsage = z.enum(['reads', 'writes', 'both']);
export const ExceptionRate = z.enum(['low', 'medium', 'high']);
/** process.status — see docs/BUILD.md §5.2 and §9. */
export const ProcessStatus = z.enum(['Draft', 'InApproval', 'Published', 'Stale', 'Orphaned', 'Retired']);
/** department_stage.stage — configurable per department, see docs/BUILD.md §5.1. */
export const ApprovalStage = z.enum(['OwnerReview', 'PeerValidation', 'DeptHeadSignoff', 'ComplianceGate']);
export const ApprovalDecision = z.enum(['Approved', 'ChangesRequested', 'Rejected']);
export const CaptureMode = z.enum(['chat', 'form', 'upload', 'voice', 'capture']);
//# sourceMappingURL=enums.js.map